<template>
    <div class="container">
        <div class="modal-header">
            <div class="title">
                <h4>404 Not Found</h4>
            </div>
        </div>
        <div class="modal-body">
            <p>ページが見つかりません。お手数ですが、再度初めからお試しください。</p>
        </div>
        <div class="flex_center">
            <app-button
                @button-click="back"
                class="back"
                value="最初に戻る"
            />
        </div>
    </div>
</template>

<script>
/**
 * 404 Not Found
 */
import { mapActions } from 'vuex'

export default {
    name:"NotFound",
    methods:{
        ...mapActions('mode', [
            'setConfirmed'
        ]),
        back(){
            this.setConfirmed(false)
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>
.container{
    padding: 0 32px;
}
.title h4{
    letter-spacing: 2px;
    border-bottom: 1px #ccc solid;
}
.modal-body{
    margin: 16px 0 48px;
}
.flex_center >>> .back{
    font-weight:normal;
    display: inline-block;
    margin: 8px;
    padding: 16px 32px;
    color: white;
    background-color: #aaa;
    margin:0;
}
.ol_in_ol{
    list-style-type: none;
    counter-reset: ol;
}
.ol_in_ol > li::before{
    counter-increment: ol;
    content:counter(ol);
    display:inline-flex;
    width:12px;
    height:12px;
    font-size:0.85em;
    justify-content: center;
    align-items: center;
    border:0.5px solid #182430;
    border-radius: 8px;
    margin:0 7px 0 0;
}
</style>


